/**
 * Recharge wallet config — Zod schemas + inferred types.
 *
 * Admin manages USDT deposit wallet addresses shown to users during recharge.
 */
import { z } from 'zod';

// ---- Admin create -----------------------------------------------------------

export const RechargeWalletCreateSchema = z.object({
  name: z.string().min(1).max(100),
  address: z.string().min(10).max(255),
  currency: z.string().max(16).default('USDT'),
  chain_id: z.string().max(32).default('ERC20'),
  is_active: z.boolean().default(true),
  sort: z.coerce.number().int().min(0).default(0),
});

export type RechargeWalletCreateRequest = z.infer<typeof RechargeWalletCreateSchema>;

// ---- Admin patch ------------------------------------------------------------

export const RechargeWalletPatchSchema = z.object({
  name: z.string().min(1).max(100).optional(),
  address: z.string().min(10).max(255).optional(),
  currency: z.string().max(16).optional(),
  chain_id: z.string().max(32).optional(),
  is_active: z.boolean().optional(),
  sort: z.coerce.number().int().min(0).optional(),
});

export type RechargeWalletPatchRequest = z.infer<typeof RechargeWalletPatchSchema>;

// ---- List query -------------------------------------------------------------

export const RechargeWalletListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(50),
  is_active: z
    .union([z.boolean(), z.string()])
    .optional()
    .transform((v) => {
      if (v === undefined || v === '') return undefined;
      if (typeof v === 'boolean') return v;
      return v === 'true';
    }),
  currency: z.string().max(16).optional(),
  chain_id: z.string().max(32).optional(),
});

export type RechargeWalletListQuery = z.infer<typeof RechargeWalletListQuerySchema>;
